import { ActionType, orderFilterType, ordersType, reducerStoreType } from "./types";

const defaultState = {
  filters: {
    storeId: -1,
    startDate: '',
    endDate: '',
    settleStatus: -1,
    cashierNo: '',
    wallet: '',
    orderNo: '',
    payOrg: '',
    currency: ''
  },
  list: [],
  contList: [],
  payAmt: 0,
  payNum: 0,
  refundAmt: 0,
  refundNum: 0,
  total: 0,
  currentPage: 1,
  recordsPerPage: 20,
  refundModalOpen: false,
  orderDetailModalOpen: false,
  manualQueryModal: false
}

const checkFilter = (order: any, filter: orderFilterType, page: number) => {
  if (page > 1) {
    return false
  }
  let tradeTime = order.tradeTime
  if (filter.startDate) {
    if (new Date(tradeTime).getTime() < new Date(filter.startDate).getTime()) {
      return false
    }
  }
  if (filter.endDate) {
    if (new Date(tradeTime).getTime() > new Date(filter.endDate).getTime()) {
      return false
    }
  }
  if (filter.settleStatus === 1) {
    return false
  }
  if (filter.wallet && filter.wallet !== order.wallet) {
    return false
  }
  return true
}


const orders = (state: ordersType = defaultState, action: ActionType<any>) => {
  let list = null, newList = null, order = null;
  switch (action.type) {
    case 'FILTERS_VALUE_CHANGE':
      return {
        ...state,
        filters: {
          ...action.payload
        }
      }
    case 'SET_ORDERS':
      return {
        ...state,
        ...action.payload.data,
        ...action.payload.pageParams
      }
    case 'CLEAR_FILTERS':
      return {
        ...state,
        filters: { ...defaultState.filters }
      }
    case 'PAGE_PARAMS_CHANGED':
      return {
        ...state,
        ...action.payload
      }
    case 'ON_SOCKET_MESSAGE':
      list = state.list
      newList = list

      order = action.payload
      order.wallet = order.payChannel
      order.type = 0
      order.buyer = order.buyerEmail
      order.tradeTime = order.payTime

      if (!checkFilter(order, state.filters, state.currentPage)) {
        return state
      }

      newList = [order, ...list]

      return {
        ...state,
        list: newList
      }
    case 'INIT_RECORDS_PER_PAGE':
      return {
        ...state,
        recordsPerPage: action.payload.recordsPerPage
      }
    case 'REFUND_SUCC':
      return {
        ...state,
        refundModalOpen: false
      }
    case 'TOGGLE_REFUND_MODAL':
      return {
        ...state,
        refundModalOpen: action.payload.open
      }
    case 'TOGGLE_ORDER_DETAIL_MODAL':
      return {
        ...state,
        orderDetailModalOpen: action.payload.open
      }
    case 'LOGOUT':
      return {
        ...state,
        filters: {
          storeId: -1,
          startDate: '',
          endDate: '',
          settleStatus: -1,
          cashierNo: '',
          wallet: '',
          orderNo: '',
          payOrg: ''
        }
      }
    case 'TOGGLE_QUERY_MODAL':
      return {
        ...state,
        manualQueryModal: action.payload.open
      }
    case 'SET_ORDER_DETAIL':
      return {
        ...state,
        orderDetailModalOpen: true
      }
    default:
      return state;
  }
}
export const getFilters = (state: reducerStoreType) => (state.orders.filters)
export const getOrderPageParam = (state: reducerStoreType) => ({
  currentPage: state.orders.currentPage,
  recordsPerPage: state.orders.recordsPerPage
})

export default orders